import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Hoagies from '../../images/Hoagies.png'
import RaceTrack from '../../images/RaceTrack.png'
import VAPED4U from '../../images/VAPED4U.png'
import Tubbees from '../../images/Tubbees.png'

export default function OtherBrands(props) {
    return (
        <div className="container">
            <h4 className="row"><u>Other Brands</u></h4>
            <div className="row">
                {props.brands.map(function (brand, i) {
                    var src; brand.name === 'Hoagies' ? src = Hoagies : brand.name === 'RaceTrack' ? src = RaceTrack : brand.name === "Tubbees" ? src = Tubbees : src = VAPED4U
                    return (
                        <div className="col-4"  key={i}>
                        <OverlayTrigger placement="bottom" delay={{ show: 150, hide: 300 }} overlay={<Tooltip>{brand.name}</Tooltip>}>
                            <img className="m-2" src={src} alt={brand.name} />
                        </OverlayTrigger>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
